import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import './utils/versionChecker' // Auto-detects updates and refreshes

console.log('Main.tsx loading...');
console.log('Current URL:', window.location.href);

const rootElement = document.getElementById('root');
if (!rootElement) {
  console.error('Root element not found!');
} else {
  console.log('Root element found, rendering app...');
  createRoot(rootElement).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
}

// Service worker removed - not needed for this application
// If you need PWA features in the future, consider using vite-plugin-pwa
